if (!customElements.get('kis-quick-order')) {
  customElements.define('kis-quick-order', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      this.addEventListener('change', (event) => {
        const select = event.target.closest('.quick-order-variant');
        if (select) this.updateRow(select.closest('.quick-order-row'));
      });
      this.addEventListener('click', (event) => {
        const button = event.target.closest('.quick-order-add, .quick-order-add-all');
        if (!button || button.disabled || this.busy) return;
        const rows = button.matches('.quick-order-add-all')
          ? Array.from(this.querySelectorAll('.quick-order-row'))
          : [button.closest('.quick-order-row')];
        this.addItems(rows);
      });
      this.querySelectorAll('.quick-order-row').forEach((row) => this.updateRow(row));
    }

    updateRow(row) {
      const selected = row.querySelector('.quick-order-variant').selectedOptions[0];
      row.querySelector('.quick-order-sku').textContent = selected.dataset.sku || '';
      row.querySelector('.quick-order-price').innerHTML = selected.dataset.price || '';
      const button = row.querySelector('.quick-order-add');
      button.disabled = selected.dataset.available !== 'true' || Boolean(this.busy);
      button.textContent = selected.dataset.available === 'true' ? 'Add' : 'Sold out';
      button.classList.toggle('sold-out', selected.dataset.available !== 'true');
    }

    async addItems(rows) {
      const status = this.querySelector('.quick-order-status');
      status.textContent = '';
      const items = [];
      for (const row of rows) {
        const input = row.querySelector('.quick-order-qty');
        const quantity = Number(input.value);
        if (!Number.isSafeInteger(quantity) || quantity < 0) {
          status.textContent = 'Enter a whole number of cases, zero or greater.';
          input.focus();
          return;
        }
        if (!quantity) continue;
        const selected = row.querySelector('.quick-order-variant').selectedOptions[0];
        if (selected.dataset.available !== 'true') {
          status.textContent = 'A selected variant is sold out. Choose another variant.';
          return;
        }
        items.push({ id: selected.value, quantity });
      }
      if (!items.length) {
        status.textContent = 'Enter a quantity before adding products.';
        return;
      }
      this.busy = true;
      this.querySelectorAll('button, input, select').forEach((control) => { control.disabled = true; });
      status.textContent = 'Adding products…';
      try {
        const response = await fetch(this.dataset.cartAddUrl, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items })
        });
        const data = await response.json();
        if (!response.ok || data.status) throw new Error(data.description || data.message || 'Unable to add products. Please try again.');
        window.location.assign(this.dataset.cartUrl);
      } catch (error) {
        status.textContent = error.message || 'Unable to add products. Please try again.';
        this.busy = false;
        this.querySelectorAll('button, input, select').forEach((control) => { control.disabled = false; });
        this.querySelectorAll('.quick-order-row').forEach((row) => this.updateRow(row));
      }
    }
  });
}
